export default {
  WAIT_FOR_EXECUTION_MS: 1000,
  DEFAULT_DEBOUNCE: 500,
  SHORT_DEBOUNCE: 200,
  SCROLL_TO_MS: 1000,
};
